import { prop, indexBy } from 'ramda'
import * as types from 'store/crowds/crowdsTypes'

const initialState = {}

const crowdsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_CROWDS_SUCCEEDED: {
      return indexBy(prop('id'), action.payload.json.crowds)
    }
    // case 'FETCH_CROWDS_FAILED' // TODO
    default: return state
  }
}

export default crowdsReducer
